module.exports = "/_next/static/files/d25f9c1f1c3d6225d98a06da6dc54dd6.svg";